import React, { useEffect } from 'react'
import img1 from '../assets/Group 818.svg';
import { useState ,useRef} from 'react';
import { GoTriangleDown } from "react-icons/go";
import { MdOutlineRefresh } from "react-icons/md";
import { Link, useNavigate } from 'react-router-dom';
//import { FaArrowLeftLong } from 'react-icons/fa6';
import { observer } from "mobx-react";
import userStore from "../store/userStore";


const Login = observer(() => {
    const [countryCode, setCountryCode] = useState('+91'); // Default country code
    const [phoneNumber, setPhoneNumber] = useState();
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const [dropDown, setDropDown] = useState(false);
    const inputRefs = useRef([
        React.createRef(),
        React.createRef(),
        React.createRef(),
        React.createRef(),
        React.createRef(),
        React.createRef(),
    ]);
    const navigate = useNavigate();
    useEffect(()=> {
        if(userStore.loggedIn){
            userStore.userLogin(false);
            navigate('/');
        }
    },[navigate]);

    const options = ['+91','+1','+44'];

    const handleOtpChange = (index, value) => {
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (index < otp.length-1 && value !== '') {
            inputRefs.current[index + 1].current.focus();
        }
        };
    
    const handleKeyDown = async (index, event) => {
        if (event.target.value === '' && index > 0 && event.key==='Backspace') {
            inputRefs.current[index - 1].current.focus();
        }
    };

    const handleCountryCodeChange = (option) => {
        setDropDown(!dropDown);
        setCountryCode(option);
    };

    // const handleBackClick = () => {
    //     navigate(-1);
    // }

    const handlePhoneNumberChange = (event) => {
        setPhoneNumber(event.target.value);
    };

    const handleSubmit = async (e) => {
        //e.preventDefault();
        //const curNumbers = userStore.getMobileNumbers();
        //const phoneNumberExists = curNumbers.includes(phoneNumber);
        // const phoneRegex = /^\d{10}$/;
        // if(!phoneRegex.test(phoneNumber)){
        //     alert("Invalid Mobile Number");
        //     setPhoneNumber('');
        //     return;
        // }
        userStore.addMobileNumber(phoneNumber);
        await userStore.userLogin(true);
        if(userStore.loggedIn) navigate('/profile');
        // if (phoneNumberExists) {
        //     navigate("/profile");
        // } else {
        //     navigate('/register');
        // }
    };
    return (
    
    <div className='overflow-x-hidden font-sans lineargradient1 h-fit w-full visible mt-16 md:mt-20'>
        {/* <div className='flex justify-start items-center'>
            <Link onClick={handleBackClick}>
                <div className='flex w-full justify-center items-center gap-2 mt-2 mx-3 cursor-pointer text-black text-md hover:text-pretty'>
                    <FaArrowLeftLong />
                    Back
                </div>
            </Link>
        </div> */}
        <div className='flex sm:flex-row justify-center items-center m-[5%] mt-2 md:mt-10 flex-col'>
            <div className='flex flex-col justify-center items-center bg-primary rounded-lg p-5 pb-0.5 pl-0 overflow-hidden'> 
                <p className='text-white text-xl md:text-3xl w-[80%] m-[5%] -mb-[5%] '>Secure your financial journey with My Credit Report.in</p>
                <img src={img1} alt="" height={600} width={600} />
            </div>
            <div className='bg-white h-1/3 max-md:w-[92%] w-96 -mt-[6%] sm:mt-0 lg:-ml-[4%] sm:-ml-[10%] rounded-lg border border-blue-500 p-4 md:p-10'>
                <h1 className='text-xl md:text-2xl font-bold md:mb-2'>Log In</h1>
                <p className='text-xs md:text-md text-gray-500 mb-2'>Secure your future, login with your CIBIL score</p>
                <p className='md:mb-1 max-md:text-sm max-md:mt-4'>Enter mobile no.</p>
                <form>
                <div className='flex flex-row gap-2 mb-4 md:mb-3'>
                    <div className='flex flex-row relative justify-around cursor-pointer items-center h-10 border border-gray-300 rounded-lg w-[20%] max-md:text-sm' onClick={()=> setDropDown(!dropDown)}>
                        {countryCode}
                        <GoTriangleDown className={`${dropDown ? "rotate-180": ""}`}/>
                            <div className={`absolute transition-all duration-200 will-change-auto ease-in-out bg-white border border-gray-300 rounded-md shadow-md ${dropDown ? "top-full scale-100" : "-top-full scale-0"}`}>
                            {options.map((option, index) => (
                                <div
                                    key={index}
                                    className="cursor-pointer p-2 hover:bg-gray-100"
                                    onClick={() => handleCountryCodeChange(option)}
                                >
                                {option}
                                </div>
                            ))}
                            </div>
                    </div>
                    <input
                        className=' h-10 border border-gray-300 rounded-lg w-full text-center'
                        type="tel"
                        value={phoneNumber}
                        onChange={handlePhoneNumberChange}
                        required
                    >
                    </input>
                </div>
                <p className='max-md:text-sm'>Enter OTP</p>
                <div className='flex flex-row items-center gap-2'>
                {otp.map((digit, index) => (
                    <input
                        className='flex flex-row justify-center items-center h-10 border border-gray-300 rounded-lg w-full text-center'
                        key={index}
                        type="number"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleOtpChange(index, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        ref={inputRefs.current[index]}
                        required
                    />
                ))}
                </div>
                <div className='flex flex-row w-full md:gap-1 justify-end items-center max-md:mt-4'>
                    <button type="button" className='text-[9px] md:text-sm text-gray-500 hover:text-black max-md:px-1'>Resend Otp</button>
                    <MdOutlineRefresh className='text-gray-500 max-md:text-[10px]'/>
                </div>
                <div className='flex flex-row justify-center w-full mt-5'>
                    <Link onClick={handleSubmit}>
                        <button className="bg-primary hover:text-gray-200 px-4 text-white rounded-md h-12">Get free Cibil Score</button>
                    </Link>
                </div>
                </form>
            </div>
        </div>
        <p className='sr-only'>KGST</p>
    </div>
    )
});

export default Login